import { object } from "../helpers/object";
import { debug } from "../helpers/debug";
import { utils } from "../helpers/utils";

import { animation } from "../helpers/animation";
import { throttle } from "throttle-debounce";

/*------------------------------------*\
  #SCROLL-TO

  Class gestion des element [data-js-component="scroll-to"]

  [data-js-component="scroll-to"]
\*------------------------------------*/
class ScrollTo {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT
    document.addEventListener('click', this.clickHandler);
    // SCROLL EVENT HANDLER
    document.addEventListener('scroll', this.scrollHandler);
    // KEY EVENTS
    document.addEventListener('keyup', this.keyHandler);
    // INIT SCROLL HASH
    this.hashScrollTo();    

    if(debug.DEBUG) console.log('async/scroll-to.js');
  }
  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    if (event.target.matches('[data-js-trigger="scroll-to"]')) {
      event.preventDefault();
      if (event.target.matches('[aria-current="true"]')) return;

      // links scroll to
      this.activation(event.target);
    }
  }
  /**
   * CLOSE ON ESC KEY
   * 
   * Fermeture des sub-nav au clic sur la touche echap
   * @param {event} event 
   */
  keyHandler = (event) => {
    const { key, keyCode, target } = event;
    if (target.matches('[data-js-trigger="scroll-to"]')) {
      event.preventDefault();
      if (!target.matches('[aria-current="true"]') && utils.isTabKey(key || keyCode)) {
        this.activation(target);
      }
    }
  }
  /**
   * ACTIVATION
   * 
   * enable du lien current
   * disable ancien lien
   * scroll to section ID
   * @param {HTMLElement} element 
   * @returns 
   */
  activation = (element) => {
    // links scroll to
    const id = this.getId(element);
    const target = this.getTarget(id);

    if (!target) return false;
    window.location.hash = `scroll-to:${id}`;
    this.scroll(this.getScrollTopPosition(target, element));
    this.currentDisable();
    this.currentSelect(element);

  }
  /**
   * SCROLL HANDLER
   * @param {event} event 
   */
  scrollHandler = (event) => {
    this.activeOnScrollHandler();
  };
  /**
   * ACTIVE ON SCROLL HANDLER
   */
  activeOnScrollHandler = throttle(100, () => {
    this.DOM_MODULE.forEach(element => {
      const id = this.getId(element);
      const target = this.getTarget(id);
      // declenche le scroll si l'element est visible 1/3 de la hauteur de la fenetre
      const scrollTopPosition = this.getScrollTopPosition(target, element) - (window.innerHeight / 5);
      if (scrollTopPosition - window.scrollY <= 0 && element.matches('[aria-current="false"]')) {
        this.currentDisable();
        this.currentSelect(element);
      }
    });
  })
  /**
   * CURRENT DESELECT
   * 
   * Désélection de la variation en cours
   * 
   * @param {HTMLElement} module 
   * @returns 
   */
  currentDisable = () => {
    this.DOM_MODULE.forEach((element) => {
      if (element.matches('[aria-current="true"]')) {
        element.setAttribute('aria-current', false);
      }
    });
  }
  /**
   * CURRENT SELECT
   * 
   * selection de la variation
   * 
   * @param {HTMLElement} module 
   * @param {string} name 
   * @returns 
   */
  currentSelect = (element) => {
    element.setAttribute('aria-current', true);
  }
  /**
   * HASH SCROLL TO
   * 
   * @returns 
   */
  hashScrollTo = () => {
    const hash = window.location.hash;
    const regex = new RegExp('#scroll-to:');
    if (regex.test(hash)) {
      const id = hash.replace('scroll-to:', '');
      const trigger = document.querySelector(`a[href="${id}"]`);
      if (!trigger) return;
      setTimeout(() => {
        trigger.click();
      }, 1000)
    }
  }
  /**
   * GET ID
   * 
   * return id from href
   * @param {HTMLElement} element 
   * @returns {string}
   */
  getId = (element) => {
    return element.getAttribute('href').replace('#', '');
  }
  /**
   * GET TARGET
   * 
   * return element from id
   * @param {string} id 
   * @returns {HTMLElement}
   */
  getTarget = (id) => {
    return document.getElementById(id);
  }
  /**
   * GET SCROLL TOP POSITION
   * @param {HTMLElement} target // cible pour le scroll
   * @param {HTMLElement} element // trigger du scoll
   * @returns 
   */
  getScrollTopPosition = (target, element) => {
    if (!target) return;
    let gap = 0;
    if (element.closest('.c-product-nav-details')) gap = 56;
    else if (element.closest('.m-table-of-contents')) gap = 82;
    return target.offsetTop - gap;
  }
  /**
   * SCROLL 
   * 
   * @param {number} scrollTopPosition 
   */
  scroll = (scrollTopPosition) => {
    animation.scrollTo(scrollTopPosition, 1000);
  }

}
export default new ScrollTo('[data-js-trigger="scroll-to"]'); 